import script from "./EducationSection.vue?vue&type=script&setup=true&lang=js"
export * from "./EducationSection.vue?vue&type=script&setup=true&lang=js"

import "./EducationSection.vue?vue&type=style&index=0&id=247d32a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-247d32a8"]])

export default __exports__